function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEquipments = function SvgEquipments(props) {
  return React.createElement("svg", _extends({
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    id: "surface1"
  }, React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 18.828125 20.898438 L 6.832031 20.898438 C 6.800781 20.898438 6.773438 20.921875 6.773438 20.953125 L 6.773438 21.992188 C 6.773438 22.023438 6.800781 22.050781 6.832031 22.050781 L 18.828125 22.050781 C 18.855469 22.050781 18.882813 22.023438 18.882813 21.992188 L 18.882813 20.953125 C 18.882813 20.921875 18.855469 20.898438 18.828125 20.898438 "
  }), React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 10.550781 17.378906 C 8.933594 17.941406 7.589844 19.09375 6.773438 20.574219 L 18.882813 20.574219 C 18.019531 19.007813 16.5625 17.808594 14.816406 17.285156 C 16.453125 16.515625 17.640625 14.929688 17.839844 13.066406 C 18.066406 10.972656 17.054688 9.089844 15.449219 8.050781 C 15.449219 8.070313 15.457031 8.089844 15.457031 8.113281 C 15.457031 8.496094 15.195313 8.820313 14.84375 8.917969 C 16.160156 9.761719 16.988281 11.308594 16.773438 13.023438 C 16.539063 14.921875 15.011719 16.449219 13.113281 16.683594 C 11.851563 16.839844 10.679688 16.4375 9.816406 15.6875 L 12.171875 15.6875 C 12.203125 15.6875 12.230469 15.660156 12.230469 15.628906 L 12.230469 14.355469 C 12.230469 14.324219 12.203125 14.300781 12.171875 14.300781 L 5.175781 14.300781 C 5.144531 14.300781 5.117188 14.324219 5.117188 14.355469 L 5.117188 15.628906 C 5.117188 15.660156 5.144531 15.6875 5.175781 15.6875 L 8.363281 15.6875 C 8.925781 16.425781 9.679688 17.015625 10.550781 17.378906 "
  }), React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 13.921875 8.09375 C 13.921875 8.464844 14.222656 8.765625 14.59375 8.765625 C 14.964844 8.765625 15.265625 8.464844 15.265625 8.09375 C 15.265625 7.722656 14.964844 7.417969 14.59375 7.417969 C 14.222656 7.417969 13.921875 7.722656 13.921875 8.09375 "
  }), React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 10.425781 11.347656 C 10.453125 11.375 10.503906 11.375 10.535156 11.347656 L 11.53125 10.347656 C 11.5625 10.316406 11.5625 10.269531 11.53125 10.238281 L 10.265625 8.972656 C 10.238281 8.941406 10.1875 8.941406 10.15625 8.972656 L 9.160156 9.972656 C 9.128906 10 9.128906 10.050781 9.160156 10.078125 Z M 10.425781 11.347656 "
  }), React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 16.820313 5.324219 C 16.855469 5.359375 16.910156 5.359375 16.941406 5.324219 L 18.523438 3.742188 C 18.558594 3.710938 18.558594 3.65625 18.523438 3.621094 L 16.882813 1.980469 C 16.851563 1.949219 16.796875 1.949219 16.761719 1.980469 L 15.179688 3.5625 C 15.148438 3.59375 15.148438 3.652344 15.179688 3.683594 Z M 16.820313 5.324219 "
  }), React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.725281%,38.038635%,57.255554%)",
      fillOpacity: 1
    },
    d: "M 11.871094 10.144531 C 11.941406 10.214844 12.054688 10.214844 12.121094 10.144531 L 13.824219 8.445313 C 13.765625 8.328125 13.730469 8.199219 13.730469 8.0625 C 13.730469 7.601563 14.097656 7.226563 14.554688 7.222656 C 14.695313 7.222656 14.828125 7.261719 14.945313 7.320313 L 16.546875 5.71875 C 16.617188 5.648438 16.617188 5.535156 16.546875 5.46875 L 15.039063 3.957031 C 14.96875 3.886719 14.855469 3.886719 14.785156 3.957031 L 10.359375 8.382813 C 10.289063 8.453125 10.289063 8.566406 10.359375 8.636719 Z M 11.871094 10.144531 "
  })));
};

export default __webpack_public_path__ + "static/media/equipments.a80ef0d8.svg";
export { SvgEquipments as ReactComponent };